import type { Node } from "reactflow";

import type {
  JourneyNodeData,
  JourneyNodeDetails,
} from "src/pages/journeys/types";
import {
  type EntryAudienceExperimentBranchConfig,
  JourneyNodeType,
  type SegmentBranchConfig,
  type SplitBranchConfig,
  type SplitsConfig,
  type WaitUntilEventBranchConfig,
} from "src/types/journeys";

export function isSegmentBranchNodeDetails(
  nodeData: JourneyNodeData,
): nodeData is JourneyNodeDetails<SegmentBranchConfig> {
  return (
    "config" in nodeData &&
    nodeData.config.type === JourneyNodeType.SegmentBranch
  );
}

export function isSplitBranchNodeDetails(
  nodeData: JourneyNodeData,
): nodeData is JourneyNodeDetails<SplitBranchConfig> {
  return (
    "config" in nodeData && nodeData.config.type === JourneyNodeType.SplitBranch
  );
}

export function isSegmentBranchNode(
  node: Node<JourneyNodeData>,
): node is Node<JourneyNodeDetails<SegmentBranchConfig>> {
  return (
    "config" in node.data &&
    node.data.config.type === JourneyNodeType.SegmentBranch
  );
}

export function isSplitNode(
  node: Node<JourneyNodeData>,
): node is Node<JourneyNodeDetails<SplitsConfig>> {
  return (
    "config" in node.data && node.data.config.type === JourneyNodeType.Splits
  );
}

export function isSplitBranchNode(
  node: Node<JourneyNodeData>,
): node is Node<JourneyNodeDetails<SplitBranchConfig>> {
  return (
    "config" in node.data &&
    node.data.config.type === JourneyNodeType.SplitBranch
  );
}

export function isWaitUntilBranchNode(
  node: Node<JourneyNodeData>,
): node is Node<JourneyNodeDetails<WaitUntilEventBranchConfig>> {
  return (
    "config" in node.data &&
    node.data.config.type === JourneyNodeType.WaitUntilEventBranch
  );
}

export function isEntryAudienceExperimentBranchNodeDetails(
  nodeData: JourneyNodeData,
): nodeData is JourneyNodeDetails<EntryAudienceExperimentBranchConfig> {
  return (
    "config" in nodeData &&
    nodeData.config.type === JourneyNodeType.EntryAudienceExperimentBranch
  );
}

export function isEntryAudienceExperimentBranchNode(
  node: Node<JourneyNodeData>,
): node is Node<JourneyNodeDetails<EntryAudienceExperimentBranchConfig>> {
  return (
    "config" in node.data &&
    node.data.config.type === JourneyNodeType.EntryAudienceExperimentBranch
  );
}
